var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subpixel-antialiased",attrs:{"id":"wrapper"}},[_c('Header'),_c('div',{staticClass:"px-5"},[_c('Filters'),_c('Body',{staticClass:"flex-grow"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }